import {extend, configure} from 'vee-validate/dist/vee-validate.full';
import {parse} from 'vue-currency-input';
import store from './store/store';

import errorMessages from './errormessages.json';
window.errorMessages = errorMessages;

const formatter = new Intl.NumberFormat('hu-HU', {
  maximumFractionDigits: 0,
});

configure({
  classes: {
    invalid: 'is-invalid',
  },
});

extend('int_required', (value) => {
  if (value == 1) return true;
});

extend('csomag', (value) => {
  if (value == 1) return true;
});

extend('int_not_required', (value) => {
  if (value !== 1) return true;
});

extend('currency_min', {
  validate(value, {min}) {
    if (value >= min) return true;
    if (typeof value !== 'string') return false;
    return parse(value, window.currencyInputOptions) >= min;
  },
  params: ['min'],
});

extend('currency_max', {
  validate(value, {max}) {
    if (value <= max) return true;
    if (typeof value !== 'string') return false;
    return parse(value, window.currencyInputOptions) <= max;
  },
  params: ['max'],
});

extend('valuables_above_200_min', (value) => {
  const data = store.state.chooseableAccesories;
  if (data.valuesAbove200Sum >= data.valuesAbove200Minimum) return true;
  return `A négy mező értékének el kell érnie a ${formatter.format(
    data.valuesAbove200Minimum
  )} forintot. Hiányzik: ${formatter.format(
    data.valuesAbove200Minimum - data.valuesAbove200Sum
  )} Ft.`;
});

extend('valuables_above_200_max', (value) => {
  const data = store.state.chooseableAccesories;
  if (data.valuesAbove200Sum <= data.valuesAbove200Maximum) return true;
});

extend('kockazat_kezdet', (value) => {
  const now = new Date();
  // const now = new Date(2025, 0, 15);
  const maxDate = new Date().setDate(now.getDate() + 180);

  if (value >= now && value <= maxDate) return true;
});

extend('szerzodes_szuletes_datum', (value) => {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
  const minDate = new Date();
  minDate.setFullYear(1900);
  minDate.setMonth(1);
  minDate.setDate(1);
  const maxDate = new Date(today);

  return !(value > maxDate || value < minDate);
});

extend('szuletes_datum', (value) => {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
  const minDate = new Date();
  minDate.setFullYear(1900);
  minDate.setMonth(1);
  minDate.setDate(1);

  return !(value > today || value < minDate);
});

extend('zip_code', (_, [city_name]) => {
  if (city_name) {
    if (city_name != 'Hibás irányítószám') return true;
  } else {
    if (
      (store.state.generalInfo.propertyName != 'Hibás irányítószám' &&
        !Array.isArray(store.state.generalInfo.propertyName)) ||
      (Array.isArray(store.state.generalInfo.propertyName) && store.state.generalInfo.propertyName)
    )
      return true;
  }
});

extend('email_verify_code', (value) => {
  if (btoa(value) == store.state.email_valid_code) return true;
});

extend('adoszam', (value) => {
  return value.length === 13;
});

extend('required_checkbox', (value) => {
  if (value) return true;
});

extend('valid_zip', (value) => {
  const zipCodeList = Object.keys(store.state.cities);
  return zipCodeList.includes(value);
});
